// War card game data with rankings
export const WAR_CARDS = [
  { id: 1, name: "Battleship", rank: 1 , image: "/images/war/war_1.jpg"},
  { id: 2, name: "Trebuchet", rank: 2 , image: "/images/war/war_2.jpg"},
  { id: 3, name: "Destroyer", rank: 3 , image: "/images/war/war_3.jpg"},
  { id: 4, name: "F-35", rank: 4 , image: "/images/war/war_4.jpg"},
  { id: 5, name: "Aircraft Carrier", rank: 5 , image: "/images/war/war_5.jpg"},
  { id: 6, name: "B-2", rank: 6 , image: "/images/war/war_6.jpg"},
  { id: 7, name: "F-18", rank: 7 , image: "/images/war/war_7.jpg"},
  { id: 8, name: "Growler", rank: 8 , image: "/images/war/war_8.jpg"},
  { id: 9, name: "Hawkeye", rank: 9 , image: "/images/war/war_9.jpg"},
  { id: 10, name: "Aegis Cruiser", rank: 10 , image: "/images/war/war_10.jpg"},
  { id: 11, name: "Globemaster", rank: 11 , image: "/images/war/war_11.jpg"},
  { id: 12, name: "F-22 Raptor", rank: 12 , image: "/images/war/war_12.jpg"},
  { id: 13, name: "M1A2 Abrams", rank: 13 , image: "/images/war/war_13.jpg"},
  { id: 14, name: "Challenger 3", rank: 14 , image: "/images/war/war_14.jpg"},
  { id: 15, name: "Leopard 2PL", rank: 15 , image: "/images/war/war_15.jpg"},
  { id: 16, name: "Ohio Class Sub", rank: 16 , image: "/images/war/war_16.jpg"},
  { id: 17, name: "Vanguard Class Sub", rank: 17 , image: "/images/war/war_17.jpg"},
  { id: 18, name: "Akula Class Sub", rank: 18 , image: "/images/war/war_18.jpg"},
  { id: 19, name: "Seawolf Class Sub", rank: 19 , image: "/images/war/war_19.jpg"},
  { id: 20, name: "Virginia Class Sub", rank: 20 , image: "/images/war/war_20.jpg"},
  { id: 21, name: "M198 howitzer", rank: 21 , image: "/images/war/war_21.jpg"},
  { id: 22, name: "Scythe", rank: 22 , image: "/images/war/war_22.jpg"},
  { id: 23, name: "SAM", rank: 23 , image: "/images/war/war_23.jpg"},
  { id: 24, name: "RPG", rank: 24 , image: "/images/war/war_24.jpg"},
  { id: 25, name: "Swiss Army knife", rank: 25 , image: "/images/war/war_25.jpg"},
  { id: 26, name: "Swiss Guard", rank: 26 , image: "/images/war/war_26.jpg"},
  { id: 27, name: "Tomahawk Missile", rank: 27 , image: "/images/war/war_27.jpg"},
  { id: 28, name: "Patriot missile", rank: 28 , image: "/images/war/war_28.jpg"},
  { id: 29, name: "Rope", rank: 29 , image: "/images/war/war_29.jpg"},
  { id: 30, name: "Rocks", rank: 30 , image: "/images/war/war_30.jpg"}
];
